/** @format */

import React from 'react'
import {Link} from 'react-router-dom'

import {Alert} from '@src/components/tailwind/Alert'

import {AnalyticsEvent, sendAnalytics} from '@src/analytics'

import {useSubmissionsContext} from './SubmissionsContext'
import {pluralize} from './utils'

export function OverlimitBanner() {
  const {data, filter, overlimitCount, setFilter, setSearch} =
    useSubmissionsContext()

  if (overlimitCount === 0) {
    return null
  }

  const isInFolder = filter.folder === 'overlimit'
  // null means no finite limit
  const hasRoom =
    data.overlimit_remaining == null || data.overlimit_remaining > 0

  function goToFolder() {
    setFilter({folder: 'overlimit'})
    setSearch('')
  }

  return (
    <Alert type="warning">
      <p className="text-sm">
        <span className="font-bold">
          {overlimitCount} {pluralize(overlimitCount, 'submission')} in your{' '}
          {isInFolder ? (
            // already in the folder — a link back to it would go nowhere
            <span className="text-primary">Over Limit</span>
          ) : (
            <button
              className="primaryLink cursor-pointer font-bold"
              onClick={goToFolder}
              type="button"
            >
              Over Limit
            </button>
          )}{' '}
          folder {overlimitCount === 1 ? "wasn't" : "weren't"} processed
        </span>
        <span>
          {' '}
          (not emailed or sent to plugins) because your account was over its
          monthly limit when {overlimitCount === 1
            ? 'it was'
            : 'they were'}{' '}
          received.{' '}
        </span>
        {!hasRoom ? (
          <Link
            className="primaryLink"
            onClick={() =>
              sendAnalytics(AnalyticsEvent.upgrade_clicked, {
                feature: 'overlimit',
              })
            }
            to="/plans"
          >
            Upgrade for more →
          </Link>
        ) : isInFolder ? (
          <span>Select submissions below to Reprocess.</span>
        ) : (
          <span>
            Visit your{' '}
            <button
              className="primaryLink cursor-pointer"
              onClick={goToFolder}
              type="button"
            >
              Over Limit folder
            </button>{' '}
            to Reprocess.
          </span>
        )}
      </p>
    </Alert>
  )
}
